if (typeof loadeMoreSlider_G === 'undefined') {
	globalThis.loadeMoreSlider_G = null;
}

(function () {
	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");
		const dir = document.querySelector('html').getAttribute("dir");

		let nextEl = ".product-button-group .swiper-button-next";
		let prevEl = ".product-button-group .swiper-button-prev";
		if (dir === 'rtl') {
			[nextEl, prevEl] = [prevEl, nextEl];
		}
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				const slider = entry.target;
				if (entry.isIntersecting) {
					if (slider.swiper) return;
					new Swiper(slider, {
						pagination: {
							el: slider.querySelector(".swiper-pagination"),
							clickable: true,
						},
						navigation: {
							nextEl: nextEl,
							prevEl: prevEl,
						},
						nested: true,
						allowTouchMove: true,
						breakpoints: {
							990: {
								allowTouchMove: false,
							},
						},
					});
				} else {
					if (slider.swiper) {
						slider.swiper.destroy(true, true);
					}
				}
			});
		}, { rootMargin: "400px" });

		sliders.forEach((slider) => {
			observer.observe(slider);
		});
	};

	initSlider();
	loadeMoreSlider_G = initSlider;

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
